import { render, staticRenderFns } from "./OpenAwardSetupTab.vue?vue&type=template&id=80f8dfc4&scoped=true&"
import script from "./OpenAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./OpenAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OpenAwardSetupTab.vue?vue&type=style&index=0&id=80f8dfc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f8dfc4",
  null
  
)

export default component.exports